import React from "react";
import { useFetch } from "hooks";
import { get } from "utils/api";
import { FieldArray, useFormikContext } from "formik";

const ProductLinesForm = () => {
  const { values, errors, setFieldValue } = useFormikContext();
  const [selectedProductLine, setSelectedProductLine] = React.useState();

  const fetchCompanyProductLinesAPI = useFetch({
    apiFn: id => get(`companies/${id}/product_lines`),
    defaultValue: []
  });
  React.useEffect(() => {
    if (values.company_id)
      fetchCompanyProductLinesAPI.fetchData(values.company_id);
    return () => {};
  }, [values.company_id]);

  const companyProductLines = fetchCompanyProductLinesAPI.response;

  const avaliableProductLines = companyProductLines.filter(
    x => values.patient_product_lines.indexOf(x.value) === -1
  );

  const multipleOptions =
    companyProductLines.length > 1 || values.patient_product_lines.length == 0;

  React.useEffect(() => {
    if (companyProductLines.length == 1) {
      setFieldValue("patient_product_lines", [companyProductLines[0].value]);
    }
  }, [companyProductLines]);

  return (
    <fieldset>
      <legend>Product Line</legend>
      {errors.patient_product_lines && (
        <div>{errors.patient_product_lines}</div>
      )}
      <FieldArray
        name="patient_product_lines"
        render={arrayHelpers => (
          <div>
            {values.patient_product_lines?.map((x, index) => (
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  fontSize: "1.5em",
                  margin: 10,
                  justifyContent: "space-between"
                }}
                key={index}
              >
                <div style={{ width: 50 }}>{x}</div>
                {multipleOptions && (
                  <button
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                    style={{ margin: 0, padding: "5px" }}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            {multipleOptions && (
              <div
                style={{
                  display: "flex",
                  flex: 1
                }}
              >
                <select
                  value={selectedProductLine}
                  onChange={e => setSelectedProductLine(e.target.value)}
                  style={{ margin: 0, padding: "5px" }}
                >
                  <option />
                  {avaliableProductLines.map(x => (
                    <option key={x.value} value={x.value}>
                      {x.text}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  onClick={() =>
                    arrayHelpers.insert(
                      values.patient_product_lines.length,
                      selectedProductLine
                    )
                  }
                  style={{ margin: 0, padding: "5px" }}
                  disabled={!selectedProductLine}
                >
                  Add
                </button>
              </div>
            )}
          </div>
        )}
      />
    </fieldset>
  );
};

export default ProductLinesForm;
